import {assetUrl} from '../config.js';
import {escapeHtml} from '../layout.js';

/** 文件图标类型 */
export type FileIconKind = 'pdf' | 'excel' | 'word' | 'ppt' | 'png' | 'jpg' | 'file';

/**
 * 根据扩展名返回文件类型标签
 * @param name 文件名
 */
export const fileTypeLabel = (name: string): string => {
  const ext = fileExtension(name);
  if (['xlsx', 'xls', 'xlsm', 'csv'].includes(ext)) return '表格';
  if (['pdf'].includes(ext)) return 'PDF';
  if (['doc', 'docx'].includes(ext)) return '文档';
  if (['ppt', 'pptx'].includes(ext)) return '演示文稿';
  if (['png'].includes(ext)) return 'PNG';
  if (['jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(ext)) return '图片';
  if (['zip', 'rar', '7z'].includes(ext)) return '压缩包';
  return '文件';
};

/**
 * 根据扩展名返回图标类型
 * @param name 文件名
 */
export const fileIconKind = (name: string): FileIconKind => {
  const ext = fileExtension(name);
  if (ext === 'pdf') return 'pdf';
  if (['xlsx', 'xls', 'xlsm', 'csv'].includes(ext)) return 'excel';
  if (['doc', 'docx'].includes(ext)) return 'word';
  if (['ppt', 'pptx'].includes(ext)) return 'ppt';
  if (ext === 'png') return 'png';
  if (['jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(ext)) return 'jpg';
  return 'file';
};

/**
 * 返回文件类型图标地址
 * @param name 文件名
 */
export const fileIconUrl = (name: string): string => assetUrl(`icons/${fileIconKind(name)}.svg`);

/**
 * 渲染文件类型图标
 * @param name 文件名
 * @param className 图标容器类名
 */
export const renderFileTypeIcon = (name: string, className = 'space-drive-file-icon'): string =>
  `<span class="${className}" aria-hidden="true"><img src="${escapeHtml(fileIconUrl(name))}" alt=""></span>`;

/**
 * 返回文件夹图标地址
 * @param open 是否为打开状态
 */
export const folderIconUrl = (open = false): string => assetUrl(open ? 'icons/folder-open.svg' : 'icons/folder-closed.svg');

/**
 * 渲染文件夹图标
 * @param open 是否为打开状态
 * @param className 图标容器类名
 */
export const renderFolderIcon = (open = false, className = 'space-drive-folder-icon'): string =>
  `<span class="${className}" aria-hidden="true"><img src="${escapeHtml(folderIconUrl(open))}" alt=""></span>`;

/**
 * 提取文件扩展名
 * @param name 文件名
 */
const fileExtension = (name: string): string => {
  if (!name.includes('.')) return '';
  return name.slice(name.lastIndexOf('.') + 1).toLowerCase();
};
